import { createBrowserHistory } from 'history';
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
// Create browser history
const browserHistory = createBrowserHistory();

// Create plugins
export const reactPlugin = new ReactPlugin();

// Configure Application Insights
const appInsightsConfig = {
  connectionString: process.env.REACT_APP_INSIGHT_CONNECTION_STRING,
  extensions: [reactPlugin],
  [reactPlugin.identifier]: { history: browserHistory },
  enableAutoRouteTracking: true,
  disableAjaxTracking: false,
  disableFetchTracking: false,
  autoTrackPageVisitTime: true,
  enableCorsCorrelation: true,
  enableRequestHeaderTracking: true,
  enableResponseHeaderTracking: true,
  loggingLevelConsole: 1,
  loggingLevelTelemetry: 1,
};

// Initialize Application Insights
const appInsights = new ApplicationInsights({ config: appInsightsConfig });
if (appInsightsConfig.connectionString) {
  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
    env.tags = env.tags || [];
    env.tags['ai.cloud.role'] = process.env.REACT_APP_INSIGHT_ROLE;
  });
} 
